// extracted by mini-css-extract-plugin
export default {"content_dt":"Loja_content_dt__idak9","content_dtfilmes":"Loja_content_dtfilmes__mGYK4","wrapper":"Loja_wrapper__JbUvW"};